<div [formGroup]="form" *ngFor="let feature of features" class="row">
  <div class="col-sm-3">
    <kendo-switch [formControlName]="feature"></kendo-switch>
  </div>
  <label  class="col-sm-9" >{{ 'FEATURE_TOGGLE_' + feature | uppercase | translate }}</label>
</div>
